import React from 'react';
import propTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Button from '@material-ui/core/Button';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import AddIcon from '@material-ui/icons/Add'
import format from 'string-format';
import {Fab} from "@material-ui/core";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import {connect} from "react-redux";
import PageBase from "../../PageBase";
import Notification from "../../../common/Notification";
import ConfirmDelete from "../../../common/ConfirmDelete";
import globalStyles from "../../styles";
import {getSpecNum, getSpecStocarstvo, getSpecStocarstvoList} from "../../../redux/specStocarstvo/reducer";
import {
    deleteSpecStocarstvoRequest,
    duplicateSpecStocarstvoRequest,
    fetchSpecStocarstvoList
} from "../../../redux/specStocarstvo/fetch";
import {bindActionCreators} from "redux";


const CustomTableCell = withStyles(theme => ({
    head: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
        fontSize: 18
    },
    body: {
        fontSize: 16,
    },

}))(TableCell);

const CustomTableSmallCell = withStyles(theme => ({
    head: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
        fontSize: 18,
        width: 20
    },
    body: {
        fontSize: 16,
        width: 20
    },

}))(TableCell);

const styles = theme => ({
    row: {
        '&:nth-of-Status(odd)': {
            backgroundColor: theme.palette.background.default,
        },
    },
    button: {
        margin: theme.spacing.unit,
    }
});


export class SpecStocarstvoList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            deleteRecord: false,
            id: '',
            pgNo: 1,
            pageSize: 10,
            notify: false,
            message: '',
            error: false
        }
        this.deleteSpecStocarstvo = this.deleteSpecStocarstvo.bind(this);
        this.deleteAfterConfirmation = this.deleteAfterConfirmation.bind(this);
        this.editSpecStocarstvo = this.editSpecStocarstvo.bind(this);
        this.addSpecStocarstvo = this.addSpecStocarstvo.bind(this);
        this.sortTable = this.sortTable.bind(this);
        this.addLeadingZeroes = this.addLeadingZeroes.bind(this);
        this.formatDate = this.formatDate.bind(this);
    }
    formatDate(inputDateTime) {
        const date = new Date(inputDateTime);
        // Use 'en-GB' locale for "dd.mm.yyyy" format
        return date.toLocaleDateString('en-GB');
    }

    sortTable = (column) => {
        const { specStocarstvoList, sortDirection } = this.state;

        // Determine the sort direction
        const direction = sortDirection === 'desc' ? -1 : 1;

        // Sort the array based on the selected column
        const sortedList = specStocarstvoList.sort((a, b) => {
            if (column === 'createdAt') {
                // Sort by date for the 'createdAt' column
                const dateA = new Date(a[column].split('.').reverse().join('-'));
                const dateB = new Date(b[column].split('.').reverse().join('-'));

                if (dateA < dateB) return -direction;
                if (dateA > dateB) return direction;
            } else {
                // Sort alphabetically for other columns
                if (a[column] < b[column]) return -direction;
                if (a[column] > b[column]) return direction;
            }

            return 0;
        });

        this.setState({
            specStocarstvoList: sortedList,
            sortBy: column,
            sortDirection: sortDirection === 'asc' ? 'desc' : 'asc',
        });
    };

    componentWillMount() {
        const {fetchSpecStocarstvoList} = this.props;
        fetchSpecStocarstvoList();
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (this.props.specNum !== nextProps.specNum || this.state.specStocarstvoList !== nextProps.specStocarstvoList) {
            this.setState({ specStocarstvoList: nextProps.specStocarstvoList }, () => {
                this.sortTable('broj_spec');
            });
        }
    }

    deleteSpecStocarstvo(id) {
        this.setState({deleteRecord: true, id: id});
    }

    editSpecStocarstvo(id) {
        this.props.history.push(`/SpecStocarstvo/` + id);
    }

    duplicateSpecStocarstvo(id) {
        this.props.duplicateSpecStocarstvoRequest(id)
        this.showNotification("Успешно креиран дупликат");
        setTimeout(() => this.redirectToSpecStocarstvoList(), 1000);
    }

    redirectToSpecStocarstvoList() {
        window.location.reload()
    }

    deleteAfterConfirmation(deleteConfirmed) {
        this.setState({deleteRecord: false});
        if (deleteConfirmed) {
            /* let selectedid =  this.state.id
              Create and call deleteSpecStocarstvo action */
            const {deleteSpecStocarstvoRequest} = this.props
            deleteSpecStocarstvoRequest(this.state.id)
            this.showNotification("Успешно избришано");
        }
        this.setState({id: ''});
    }

    showNotification = (msg, err) => {
        if (err)
            this.setState({notify: true, message: msg, error: true});
        else
            this.setState({notify: true, message: msg, error: false});
    };

    handleNotificationClosed = () => {
        this.setState({
            notify: false
        });
    };

    addSpecStocarstvo() {
        this.props.history.push(`/CreateSpecStocarstvo`);
    }

    addLeadingZeroes(num) {
        const number = num ? num : 0
        const numberString = number.toString()
        const desiredLength = 4;

        if (numberString.length >= desiredLength) {
            // If the number already has 4 or more digits, return it as is
            return numberString;
        } else {
            // Add leading zeroes to make it a 4-digit number
            const numberOfZeroesToAdd = desiredLength - numberString.length;
            const leadingZeroes = '0'.repeat(numberOfZeroesToAdd);
            return leadingZeroes + numberString;
        }
    }

    render() {
        const {classes, specStocarstvoList} = this.props;
        const {notify, message, error} = this.state;
        return (
            <PageBase title="Листа спецификации сточарство">
                <Fab
                    variant="extended"
                    color="primary"
                    aria-label="add" className={classes.button}
                    onClick={this.addSpecStocarstvo}
                >
                    <AddIcon/>
                    Додади спецификација
                </Fab>
                <Table>
                    <TableHead>
                        {specStocarstvoList &&
                        <TableRow>
                            <CustomTableCell onClick={() => this.sortTable('broj_spec')}>Број на сертификат</CustomTableCell>
                            <CustomTableCell onClick={() => this.sortTable('createdAt')}>Датум на креирање</CustomTableCell>
                            <CustomTableCell onClick={() => this.sortTable('pouName')}>ПОУ</CustomTableCell>
                            <CustomTableCell>Дупликат</CustomTableCell>
                            <CustomTableSmallCell>Измени</CustomTableSmallCell>
                            <CustomTableSmallCell>Избриши</CustomTableSmallCell>
                        </TableRow>
                        }
                    </TableHead>
                    <TableBody>
                        {specStocarstvoList && specStocarstvoList.map(SpecStocarstvo => {
                            return (
                                <TableRow key={SpecStocarstvo.Broj} className={classes.row}>
                                    <CustomTableCell>{this.addLeadingZeroes(SpecStocarstvo.broj_spec)}</CustomTableCell>
                                    <CustomTableCell>{this.formatDate(SpecStocarstvo.createdAt)}</CustomTableCell>
                                    <CustomTableCell>{SpecStocarstvo.pouName}</CustomTableCell>
                                    <CustomTableCell>
                                        <Button style={globalStyles.deleteButton} variant="contained" size={"small"}
                                                aria-label="duplicate"
                                                onClick={() => this.duplicateSpecStocarstvo(SpecStocarstvo.id)}>
                                            <FileCopyIcon/>
                                        </Button>
                                    </CustomTableCell>
                                    <CustomTableCell>
                                        <Button style={globalStyles.deleteButton} variant="contained" size={"small"}
                                                aria-label="edit"
                                                onClick={() => this.editSpecStocarstvo(SpecStocarstvo.id)}>
                                            <EditIcon/>
                                        </Button>
                                    </CustomTableCell>
                                    <CustomTableCell>
                                        <Button style={globalStyles.deleteButton} variant="contained" size={"small"}
                                                aria-label="delete"
                                                onClick={() => this.deleteSpecStocarstvo(SpecStocarstvo.id)}>
                                            <DeleteIcon/>
                                        </Button>
                                    </CustomTableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
                <ConfirmDelete resourceHeader="Избриши спецификација?"
                               resourceOpis={format("Дали сте сигурни дека сакате да ја ибришете спецификацијата'{}'?", this.state.id)}
                               onModalClose={this.deleteAfterConfirmation}
                               openDeleteDialog={this.state.deleteRecord}/>

                <Notification
                    notify={notify}
                    message={message}
                    error={error}
                    closed={this.handleNotificationClosed}
                />
            </PageBase>
        );
    }
}

SpecStocarstvoList.propTypes = {
    classes: propTypes.object.isRequired,
};

const mapStateToProps = state => ({
    specStocarstvoList: getSpecStocarstvoList(state),
    specStocarstvo: getSpecStocarstvo(state),
    specNum: getSpecNum(state)
})

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        fetchSpecStocarstvoList,
        deleteSpecStocarstvoRequest,
        duplicateSpecStocarstvoRequest
    }, dispatch)
}

export default withStyles(styles)(
    connect(mapStateToProps, mapDispatchToProps)(SpecStocarstvoList))